import ShimmerScreen from "./ShimmerScreen";

const ShimmerBannerCard = () => {
    return (
        <div className="card popup-home03 shimmerbox">
            <div className="card-body">
                <div className="popup-home-pg">
                    <div className="container-chart chart-section">
                        <div className="box d-flex align-items-baseline justify-content-center oboardg_pop_icon">
                            <ShimmerScreen 
                                case="circle"
                                height="2rem"
                                width="2rem"
                            />
                        </div>
                    </div>
                    <h5 className="card-text_onbordng">
                        <ShimmerScreen 
                        case="rect"
                        height="1.5rem"
                        width="8.5rem"
                        />
                    </h5>
                    <p className="card-text popup02 d-flex flex-column gap-1 align-items-center">
                        <ShimmerScreen 
                        case="rect"
                        height="1.5rem"
                        width="10.5rem"
                        />
                        <ShimmerScreen 
                        case="rect"
                        height="1.5rem"
                        width="8.5rem"
                        />
                    </p>

                    <p className="text-center">
                        <ShimmerScreen 
                            case="rect"
                            height="2rem"
                            width="12.5rem"
                        />
                    </p>
                    <p className="content-SkipExplore cursor-pointer"></p>
                </div>
            </div>
        </div> 
    )
}

export default ShimmerBannerCard